<template>
  <div>
      <div class="row">
          <div class="col-sm-12">
              <div class="page-title-box">
                  <div class="float-right">
                      <ol class="breadcrumb">
                          <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                          <li class="breadcrumb-item active">Logs</li>
                      </ol>
                  </div>
                  <h4 class="page-title">Log</h4>
              </div>
          </div>
      </div>

      <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
              <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
              <div class="wrapper-table-default">
                  <div class="table-responsive">
                      <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                          <thead>
                              <tr>
                                  <th>Detail</th>
                                  <th>Type</th>
                                  <th>Tanggal</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(item) in dataServices" :key="item.id">
                                  <td>{{item.detail}}</td>
                                  <td>{{item.type}}</td>
                                  <td>{{dateFormat(item.created_at)}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            loading: true,
            dataServices: [],
        }
    },
    methods: {
        // LOAD SERVICE DATA
        loadData() {
            this.loading = true;
            this.$http.get(`${this.API_URL}log`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                
                if(result.success) {
                    this.dataServices = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
    },
    mounted() {
        this.loadData()
    }
}
</script>